
// SVG Icon: menu-dotted
export default { id: "terriajs-menu-dotted" };
export const id = "terriajs-menu-dotted";
export const name = "menu-dotted";
